import { Component } from "react";
import withAuth from "../withAuth";
import { compose } from "redux";
import { connect } from "react-redux";
import { IMG_EXTENSION_TYPES, PDF_EXTENSION_TYPE } from "../../constants";
import { throwErrorMessage } from "../../lib/error_helper";
import { convertPdfToImages, resizeImage } from "../../utils";

class InputPhoto extends Component {
    state = {};

    componentDidMount() {
        this.setState({
            uploadInputRef: this.upload,
        });

        this.props.handleRef(this.upload);
    }

    async imageChange(e) {
        let file = e.target.files[0];

        let fileExtensionOk = false;

        if (!file) return;

        IMG_EXTENSION_TYPES.forEach((iet) => {
            if (file.name.toLowerCase().endsWith(iet)) {
                fileExtensionOk = true;
                return;
            }
        });

        if (this.props.acceptPdfAsImage && file.name.toLowerCase().endsWith(PDF_EXTENSION_TYPE)) fileExtensionOk = true;

        if (!fileExtensionOk) {
            this.props.throwErrorMessage({
                title: "L'extension du fichier est invalide",
            });

            this.upload.value = "";
            return;
        }

        if (file.name.toLowerCase().endsWith(PDF_EXTENSION_TYPE)) {
            this.props.importImage(await convertPdfToImages(file, this.canvas));
        } else this.props.importImage(await resizeImage(file, this.image, this.canvas));
    }

    render() {
        return (
            <div className="div-center">
                <canvas
                    ref={(canvas) => {
                        this.canvas = canvas;
                    }}
                    width="800"
                    height="600"
                    style={{ display: "none" }}
                />
                <img ref={(ref) => (this.image = ref)} alt="" className="hidden" />
                <input
                    accept={"image/*" + (this.props.acceptPdfAsImage ? ",application/pdf" : "")}
                    style={{ display: "none" }}
                    id="raised-button-file"
                    type="file"
                    ref={(ref) => (this.upload = ref)}
                    onChange={this.imageChange.bind(this)}
                />
            </div>
        );
    }
}

const mapStateToProps = () => {
    return {};
};

const mapDispatchToProps = (dispatch) => {
    return {
        throwErrorMessage: (options) => dispatch(throwErrorMessage(options)),
    };
};

const options = {
    forwardRef: true,
};

export default compose(withAuth, connect(mapStateToProps, mapDispatchToProps, null, options))(InputPhoto);
